import * as React from 'react';

/**
 * Deprecated, if you're trying to use this, find another way.
 */
export const useCheckAndResetClientConfigsOnMount = (
    configs: {
        name: string;
        action: () => any;
        timeout?: number;
    }[]
) => {
    React.useEffect(() => {
        configs.forEach((config) => {
            // If config exists, perform action and then delete it
            if (NutClientConfig[config.name]) {
                const timeout = config.timeout ? config.timeout : 0;

                setTimeout(() => {
                    config.action();
                    delete NutClientConfig[config.name];
                }, timeout);
            }
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
